<template>
  <de-layout-content>
    <div class="searchView">
      <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
        <el-form-item label="组织名称" prop="keyword">
          <el-input v-model="searchForm.name" placeholder="请输入组织名称" clearable />
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-select v-model="searchForm.status" placeholder="请选择状态">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery('searchForm')">查询</el-button>
          <el-button type="" icon="el-icon-refresh" @click="resetForm('searchForm')">重置</el-button>
        </el-form-item>

        <!--        <el-form-item>-->
        <!--          <div style="margin-left:200px">-->
        <!--            <el-button type="" @click="openExpandAllChange">全部展开</el-button>-->
        <!--            <el-button type="" @click="closeExpandAllChange">全部折叠</el-button>-->
        <!--          </div>-->
        <!--        </el-form-item>-->
      </el-form>
      <div class="operator">
        <el-button type="primary" plain @click="showBizDrawer = true" size="small">审批路由配置</el-button>
        <el-button type="primary" @click="addAction" icon="el-icon-plus" size="small">新增组织</el-button>
      </div>
    </div>

    <!-- 数据列表 -->
    <div class="">
      <el-table v-loading="loading" :data="tableData" row-key="keyId" class="mt20" :default-expand-all="isExpandAll"
        :key="treeKey" :tree-props="{ children: 'child', hasChildren: child > 0 }">
        <el-table-column prop="name" label="组织名称" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="icon" label="所在地区" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.addressName }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="detailAddress" label="详细地址" align="center" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="type" label="机构类型" align="center" show-overflow-tooltip>
          <!-- 1体育局2运动中心3场馆 -->
          <template slot-scope="scope">
            <span>{{
              scope.row.type == 1
                ? "体育局"
                : scope.row.type == 2
                  ? "运动中心"
                  : "场馆"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
              @change="changeSwitch(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="有效期" align="center" width="200">
          <template slot-scope="scope">
            <template v-if="scope.row.startTime && scope.row.endTime">
              <div>{{ formatDateOnly(scope.row.startTime) }} ~ {{ formatDateOnly(scope.row.endTime) }}</div>
              <div :style="validityStyle(scope.row)" style="font-size: 12px; margin-top: 4px;">
                {{ validityText(scope.row) }}
              </div>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | timestampFormatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-link :underline="false" size="mini" type="primary" icon="el-icon-plus" @click="handleAdd(scope.row)">新增
            </el-link>
            <el-dropdown class="p10" @command="handleCommand">
              <el-link :underline="false" type="primary" icon="el-icon-more"
                style="transform: rotate(-90deg);"></el-link>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ action: 'biz', row: scope.row }" v-if="scope.row.dateType == 1">
                  <div class="commandBtn">
                    <span>审批设置</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item :command="{ action: 'edit', row: scope.row }">
                  <div class="commandBtn">
                    <i class="el-icon-edit primary"></i>
                    <span class="primary">编辑</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item :command="{ action: 'delete', row: scope.row }">
                  <div class="commandBtn">
                    <i class="el-icon-delete danger"></i>
                    <span class="danger">删除</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="formData.id ? '编辑组织' : '新增组织'" :visible.sync="dialogFormVisible">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" style="width: 100%">
        <el-form-item label="上级组织" prop="parent" v-if="!isRoot">
          <el-popover placement="bottom" popper-class="user-popper dept" width="777" trigger="click"
            v-model="popoverVisible">
            <el-tree class="filter-tree" :data="tableData" :props="defaultParentProps" ref="tree"
              @node-click="handleNodeClick">
            </el-tree>

            <el-select slot="reference" v-model="formData.parent" clearable class="de-form-sex-select"
              popper-class="tree-select" placeholder="请选择上级组织" style="width: 100%">
              <el-option v-for="item in parentList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-popover>
        </el-form-item>
        <el-form-item label="组织类型" prop="type">
          <!-- type  1体育局2运动中心3场馆 -->
          <el-radio-group v-model="formData.type">
            <el-radio :label="1" v-if="parentParams.type == 1">体育局</el-radio>
            <el-radio :label="2" v-if="parentParams.type == 1 || parentParams.type == 2">运动中心</el-radio>
            <el-radio :label="3" v-if="parentParams.type == 1 || parentParams.type == 3">场馆</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="组织名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入组织名称"></el-input>
        </el-form-item>

        <!-- status  0禁用  1 启用  -->
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效期" prop="validityPeriod">
          <el-date-picker
            v-model="formData.startTime"
            type="datetime"
            placeholder="开始日期"
            :default-time="'00:00:00'"
            :picker-options="startDatePickerOptions"              style="width: 48%; margin-right: 4%;">
          </el-date-picker>
          <el-date-picker
            v-model="formData.endTime"
            type="datetime"
            placeholder="结束日期"
            :default-time="'23:59:59'"
            :picker-options="endDatePickerOptions"              style="width: 48%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所在地区" prop="address">
          <!-- <AdministrativeArea
            @callBackTreeValue="orgFormTreeValue"
            :treeNodeVal="formData.address"
          /> -->
          <el-cascader v-model="formData.address" :options="areaSource" @change="handleChange" :props="defaultProps"
            style="width: 100%"></el-cascader>
        </el-form-item>

        <el-form-item label="详细地址">
          <el-input v-model="formData.detailAddress" type="textarea" placeholder="请输入详细地址" style="width: 100%" />
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="formData.contacts" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="formData.contactNumber" placeholder="请输入联系电话"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showBizDialog" title="组织机构审批功能设置" width="600px">
      <el-form :model="orgFormData" label-width="120px">
        <el-form-item label="组织名称">
          <span style="color: #FFFFFF;">{{ orgFormData.organizationName }}</span>
        </el-form-item>
        <el-form-item label="业务表单">
          <el-switch v-model="orgFormData.bizFormStatus" :active-value="1" :inactive-value="2"
            @change="handleBizFormSwitchChange"></el-switch>
          <div v-if="orgFormData.bizFormStatus == 1" style="margin-top: 10px;">
            <el-checkbox v-model="bizFormSelectAll" :indeterminate="bizFormIndeterminate"
              @change="handleBizFormSelectAll">全选</el-checkbox>
            <el-checkbox-group v-model="orgFormData.bizForms" @change="handleBizFormChange"
              style="display: flex; flex-direction: column; margin-top: 10px; max-height: 150px; overflow-y: auto; padding-right: 10px;">
              <el-checkbox v-for="item in bizFormOptions" :key="item.id" :label="item.id">{{ item.formName
                }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="流程表单">
          <el-switch v-model="orgFormData.flowFormStatus" :active-value="1" :inactive-value="2"
            @change="handleFlowFormSwitchChange"></el-switch>
          <div v-if="orgFormData.flowFormStatus == 1" style="margin-top: 10px;">
            <el-checkbox v-model="flowFormSelectAll" :indeterminate="flowFormIndeterminate"
              @change="handleFlowFormSelectAll">全选</el-checkbox>
            <el-checkbox-group v-model="orgFormData.flowForms" @change="handleFlowFormChange"
              style="display: flex; flex-direction: column; margin-top: 10px; max-height: 150px; overflow-y: auto; padding-right: 10px;">
              <el-checkbox v-for="item in flowFormOptions" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showBizDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitBizForm">确 定</el-button>
      </div>
    </el-dialog>

    <biz-drawer :visible.sync="showBizDrawer"></biz-drawer>
  </de-layout-content>
</template>

<script>
import axios from "axios";
import BizDrawer from "@/views/system/organization/component/BizDrawer.vue";
import * as BIZ_API from '@/api/biz'
// import AdministrativeArea from "@/components/administrativeArea/administrativeArea.vue";

import {
  edit,
  getOrgData,
  statusChange,
  getOrgDetail,
  del,
} from "@/api/system/organization";
export default {
  components: {
    // AdministrativeArea,
    BizDrawer,
  },
  data() {
    return {
      isExpandAll: false,
      dialogFormVisible: false,
      popoverVisible: false,
      treeKey: "",
      searchForm: {
        status: "",
        name: ''
      },
      formData: {},
      createByList: [],
      parentList: [],
      tableData: [],
      rules: {
        parent: [
          { required: true, message: "请选择上级组织", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择组织类型", trigger: "change" },
        ],
        name: [
          { required: true, message: "请填写组织名称", trigger: "change" },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请选择所在地区",
            trigger: "change",
          },
        ],
      },
      defaultProps: {
        children: "areaList",
        label: "name",
        value: "code",
      },
      defaultParentProps: {
        children: "child",
        label: "name",
      },
      parentParams: {},
      areaSource: [],
      startDatePickerOptions: {
        disabledDate: (time) => {
          if (this.formData.endTime) {
            return (
              time.getTime() >
              new Date(this.formData.endTime).getTime()
            );
          }
          return false;
        },
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          if (this.formData.startTime) {
            return (
              time.getTime() <
              new Date(this.formData.startTime).getTime()
            );
          }
          return false;
        },
      },

      isRoot: false,
      showBizDialog: false,
      showBizDrawer: false,
      bizFormOptions: [],
      flowFormOptions: [],
      orgFormData: {
        organizationId: null,
        organizationName: '',
        bizForms: [],
        flowForms: [],
        showBizForm: false,
        showFlowForm: false
      },
      bizFormSelectAll: false,
      flowFormSelectAll: false,
      bizFormIndeterminate: false,
      flowFormIndeterminate: false
    };
  },
  created() {
    this.getOrgDataList();
    this.getArea();
  },
  methods: {
    getOrgDataList() {
      var params = {
        ...this.searchForm,
        status: this.searchForm.status,
      };
      getOrgData(params).then((res) => {
        this.tableData = res.data;
      });
    },
    //获取区域信息
    getArea() {
      return new Promise((resolve, reason) => {
        let url = `../../administrativeArea.json`;
        axios.get(url, {}, false, true).then((res) => {
          this.areaSource = res.data;
          console.log(this.areaSource);
          resolve(res);
        });
      });
    },
    // 计算剩余有效天数
    getValidDays(row) {
      if (!row.endTime) return 0;
      const endTime = Number(row.endTime);
      if (!endTime || isNaN(endTime)) return 0;
      const now = Date.now();
      if (endTime <= now) return 0;
      return Math.ceil((endTime - now) / (1000 * 60 * 60 * 24));
    },
    // 有效期显示文字
    validityText(row) {
      const days = this.getValidDays(row);
      if (days <= 0) return '已过期';
      return `剩余 ${days} 天`;
    },
    // 有效期显示样式（颜色）
    validityStyle(row) {
      const days = this.getValidDays(row);
      if (days <= 0) return 'color: #F56C6C;'; // 已过期：红色
      if (days <= 30) return 'color: #E6A23C;'; // 即将过期（≤30天）：橙色
      return 'color: #67C23A;'; // 正常：绿色
    },
    formatDateOnly(timestamp) {
      if (!timestamp || timestamp === -1) return '-'
      const date = new Date(timestamp)
      const y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? ('0' + MM) : MM
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      return y + '-' + MM + '-' + d
    },
    handleQuery() {
      this.getOrgDataList();
    },
    addAction() {
      this.isRoot = true
      this.dialogFormVisible = true;
      //   this.parentParams = this.tableData[0]
      // console.log(this.tableData[0]);
      this.formData = {
        status: 1,
      };
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
      this.$set(this.parentParams, "type", 1);
      this.$set(this.formData, "type", 1);
    },
    resetForm(formName) {
      this.searchForm = {};
      this.getOrgDataList();
      //   this.$nextTick(() => {
      //     this.$refs[formName].resetFields();
      //   });
    },
    handleAdd(row) {
      this.isRoot = false
      this.dialogFormVisible = true;
      this.formData = {
        status: 1,
      };
      console.log(row);
      this.parentList = [
        {
          name: row.name,
          id: row.id,
        },
      ];
      this.parentParams = row;
      this.$set(this.formData, "parent", row.id);
      this.$set(this.formData, "type", row.type);
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
      console.log(this.parentList, "parentList");
    },
    handleUpdate(row) {
      console.log(row);
      this.isRoot = false
      this.dialogFormVisible = true;
      this.formData = {
        ...row,
      };
      this.parentList = [
        {
          name: row.parentName,
          id: row.parent,
        },
      ];
      this.$set(this.formData, "parent", row.parent);
      this.parentParams = row;
      //   this.$set(this.formData, "type", row.type);
      //   this.formData.address = ['天津市', '市辖区', '和平区']
    },
    openExpandAllChange() {
      this.treeKey = +new Date();
      this.isExpandAll = true
    },
    closeExpandAllChange() {
      this.treeKey = +new Date();
      this.isExpandAll = false
    },
    handleChange(val) {
      console.log(val);
      let lastVal = val ? val[val.length - 1] : [];
      this.$set(this.formData, "address", lastVal);
    },
    handleNodeClick(data, e) {
      console.log(data, e);
      this.parentList = [
        {
          ...data,
        },
      ];
      this.popoverVisible = false;
      this.parentParams = data;
      this.$set(this.formData, "parent", data.id);
      this.$set(this.formData, "type", data.type);
      console.log(this.parentList, "parentList");
      console.log(this.parentParams, "parentParams");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.formData,
            startTime: this.formData.startTime
              ? new Date(this.formData.startTime).getTime()
              : null,
            endTime: this.formData.endTime
              ? new Date(this.formData.endTime).getTime()
              : null,
          };
          edit(data).then((res) => {
            console.log(res);
            if (res.code === 200) {
              this.dialogFormVisible = false;
              this.$message.success("操作成功");
              this.getOrgDataList();
            }
          });
          console.log(data);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeSwitch(row) {
      var params = {
        id: row.id, //组织结构ID
        status: row.status, //状态1开启0禁用
      };
      statusChange(params).then((res) => {
        this.$message.success("状态修改成功");
        this.getOrgDataList();
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除该组织, 是否继续?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row.id,
          };
          del(params).then((res) => {
            this.$message.success("操作成功");
            this.getOrgDataList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleBiz(row) {
      BIZ_API.listBpmBusinessFormOrg({ organizationId: row.id }).then(res => {
        this.showBizDialog = true
        this.orgFormData = {
          organizationId: row.id,
          organizationName: row.name,
          bizForms: res.data.bizForms.map(item => item.formId) || [],
          flowForms: res.data.flowForms.map(item => item.formId) || [],
          bizFormStatus: res.data.bizFormStatus || 2,
          flowFormStatus: res.data.flowFormStatus || 2
        }
        console.log(this.orgFormData)
        // 初始化全选状态
        this.$nextTick(() => {
          this.updateBizFormSelectAllState();
          this.updateFlowFormSelectAllState();
        });
      })
      BIZ_API.listBpmBusinessFormSelect({}).then(res => {
        this.bizFormOptions = res.data || []
      })
      BIZ_API.getFormSimpleList({}).then(res => {
        this.flowFormOptions = res.data || []
      })
    },
    handleCommand(e) {
      if (e.action == 'edit') {
        this.handleUpdate(e.row)
      }
      if (e.action == 'delete') {
        this.handleDelete(e.row)
      }
      if (e.action == 'biz') {
        this.handleBiz(e.row)
      }
    },
    handleBizFormSelectAll(val) {
      if (val) {
        this.orgFormData.bizForms = this.bizFormOptions.map(item => item.id);
        this.bizFormIndeterminate = false;
      } else {
        this.orgFormData.bizForms = [];
        this.bizFormIndeterminate = false;
      }
    },
    handleFlowFormSelectAll(val) {
      if (val) {
        this.orgFormData.flowForms = this.flowFormOptions.map(item => item.id);
        this.flowFormIndeterminate = false;
      } else {
        this.orgFormData.flowForms = [];
        this.flowFormIndeterminate = false;
      }
    },
    handleBizFormChange() {
      this.updateBizFormSelectAllState();
    },
    handleFlowFormChange() {
      this.updateFlowFormSelectAllState();
    },
    updateBizFormSelectAllState() {
      const checkedCount = this.orgFormData.bizForms.length;
      const totalCount = this.bizFormOptions.length;
      this.bizFormSelectAll = checkedCount === totalCount && totalCount > 0;
      this.bizFormIndeterminate = checkedCount > 0 && checkedCount < totalCount;
    },
    updateFlowFormSelectAllState() {
      const checkedCount = this.orgFormData.flowForms.length;
      const totalCount = this.flowFormOptions.length;
      this.flowFormSelectAll = checkedCount === totalCount && totalCount > 0;
      this.flowFormIndeterminate = checkedCount > 0 && checkedCount < totalCount;
    },
    handleBizFormSwitchChange(val) {
      if (val === 2) {
        // 开关关闭时清空选项
        this.orgFormData.bizForms = [];
        this.bizFormSelectAll = false;
        this.bizFormIndeterminate = false;
      }
    },
    handleFlowFormSwitchChange(val) {
      if (val === 2) {
        // 开关关闭时清空选项
        this.orgFormData.flowForms = [];
        this.flowFormSelectAll = false;
        this.flowFormIndeterminate = false;
      }
    },
    submitBizForm() {
      const params = {
        organizationId: this.orgFormData.organizationId,
        bizFormStatus: this.orgFormData.bizFormStatus,
        flowFormStatus: this.orgFormData.flowFormStatus,
        list: []
      };
      if (this.orgFormData.bizForms.length > 0) {
        this.orgFormData.bizForms.forEach(item => {
          params.list.push({
            formId: item,
            formType: 1
          });
        });
      }
      if (this.orgFormData.flowForms.length > 0) {
        this.orgFormData.flowForms.forEach(item => {
          params.list.push({
            formId: item,
            formType: 2
          });
        });
      }
      BIZ_API.saveBpmBusinessFormOrg(params).then(res => {
        if (res.code === 200) {
          this.$message.success('审批功能设置保存成功');
          this.showBizDialog = false;
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep.el-cascader-menu__wrap.el-cascader-menu__wrap {
  height: 204px;
}

.searchView {
  padding: 24px;
  background: #21284B;
  margin-bottom: 22px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .el-form-item {
    margin-bottom: 0;
  }
}

.commandBtn {
  display: flex;
  flex-direction: row;
  align-items: center;

  .primary {
    color: #1890FF;
  }

  .danger {
    color: #F56C6C;
  }
}
</style>
